import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { RecordStateEnum } from "src/app/shared/enums";
import { AuthenticationService } from "src/app/shared/services";

import { BulkAddLocationsService } from "@components/locations/bulk-add-locations/bulk-add-locations.service";
import { TextConstants } from "@shared/constants";
import { RouterService } from "@shared/services/router.service";

import { AddGeoJsonLocationsComponent } from "./add-geojson-locations/add-geojson-locations.component";
import {
  AddLocationOptionsDialogComponent,
  AddLocationOptionEnum,
} from "./add-location-options-dialog/add-location-options-dialog.component";

@Component({
  standalone: false,
  selector: "app-locations",
  templateUrl: "./locations.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationsComponent {
  public readonly recordStateEnum = RecordStateEnum;

  public readonly hasEntitiesWriteAccess = this.authenticationService.hasEntitiesWriteAccess;

  public readonly translations: any = {
    title: $localize`:@@shared.locations:Locations`,
    titleHint: $localize`:@@locations.help:Access and manage all your and external locations. Edit, view details, and create new ones to streamline your operations.`,
    addNewLabel: TextConstants.ADD_NEW,
  };

  constructor(
    private router: RouterService,
    private dialog: MatDialog,
    public authenticationService: AuthenticationService,
    private bulkAddLocationsService: BulkAddLocationsService,
  ) {}

  public onAdd(): void {
    this.router.navigate(this.router.getLocationLink());
  }

  public async onOpenBulkAddLocationsSlideOver(): Promise<void> {
    const dialogRef = this.dialog.open(AddLocationOptionsDialogComponent);

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === AddLocationOptionEnum.MANUAL_ENTRY) {
        await this.bulkAddLocationsService.openSlideOver();
      } else if (result === AddLocationOptionEnum.GEOJSON_FILES) {
        await this.handleGeojsonFilesUpload();
      }
    });
  }

  private async handleGeojsonFilesUpload(): Promise<void> {
    this.dialog.open(AddGeoJsonLocationsComponent);
  }
}
